import axios from "../general/HttpClient";
import * as AccountStore from "../account/AccountStore";

export function SearchAllUsers(query, skip, limit) {
    return axios.get("/api/users/searchAllUsers", {
        params: {
            query,
            skip,
            limit,
        },
    });
}

export function SearchUsers(query, skip, limit, includeStaff, includeStudents, includeParents, includeGuests) {
    return axios.get("/api/users/searchUsers", {
        params: {
            query,
            skip,
            limit,
            includeStaff,
            includeStudents,
            includeParents,
            includeGuests,
        },
    });
}

export function GetUser(userId) {
    return axios.get("/api/users/getUser", {
        params: {
            userId,
        },
    });
}

export function GetUserClaims(userId) {
    return axios.get("/api/users/getUserClaims", {
        params: {
            userId,
        },
    });
}

export function ResolveUsers(users) {
    return axios.post("/api/users/$resolve", { users });
}

export function CreateUser(request: CreateIdentityUserRequest) {
    return axios.post("/api/users/createUser", request);
}

export function UpdateUser(request: UserUpdateModel) {
    return axios.post("/api/users/UpdateUser", request);
}

export interface UserUpdateModel {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    twoFactorEnabled: boolean;
}

export function AddUserToOrganization(userId, organizationId, membershipType, source, sourceID) {
    return axios.post(
        "/api/users/addUserToOrganization",
        {},
        {
            params: {
                userId,
                organizationId,
                membershipType,
                source,
                sourceID,
            },
        }
    );
}

export function RemoveUserFromOrganization(userId, organizationId, membershipType) {
    return axios.delete("/api/users/removeUserFromOrganization", {
        params: {
            userId,
            organizationId,
            membershipType,
        },
    });
}

export const ImportUsersFromExcel = (organizationId, excelFileData) => {
    return axios.post(
        `api/users/importUsersFromExcel`,
        { excelFileData },
        {
            params: {
                organizationId,
            },
        }
    );
};

export const ImportUsersFromExcelTestRun = (organizationId, excelFileData) => {
    return axios.post(
        `api/users/importUsersFromExcelTestRun`,
        { excelFileData },
        {
            params: {
                organizationId,
            },
        }
    );
};

export const ResetPassword = (user, password) => {
    return axios.post(`api/users/resetPassword`, { userID: user.id, password });
};

export const GetAdmins = () => {
    return axios.get(`api/users/$admins`);
};

export const AddClaim = (userID, type, value) => {
    return axios.post(`api/users/claims`, { userID: userID, claimType: type, claimValue: value });
};

export const RemoveClaim = (userId, claimType, claimValue) => {
    return axios.delete(`api/users/claims`, { params: { userId, claimType, claimValue } });
};

export class Organization {
    id: string;
    name: string;
    scadsysOnlineSchoolID: string;
    defaultDomain: string;
    logoUri: string;
}

export class OrganizationMembership {
    userID: string;
    organizationID: string;
    type: number;
    enabled: boolean;
    source: string;
    sourceID: string;
    user: AccountStore.Account;
    organization: Organization;
}

export interface IdentityUser {
    organization: string;
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    photo: string;
    hasGivenAccessTo: DelegatedAccess[];
    groups: any[];
    membershipType: any;
    sourceIdentifiers: SourceIdentifier[];
}

export interface DelegatedAccess {
    delegatorID: string;
    delegateeID: string;
    delegationRules: string;
}

export interface SourceIdentifier {
    source: string;
    sourceID: string;
}

export interface CreateIdentityUserRequest {
    id?: string;
    userName?: string;
    email: string;
    firstName?: string;
    lastName?: string;
    membershipType: number;
    sourceID?: string;
    source?: string;
    organization: string;
    photo?: string;
    phoneNumber?: string;
}
